function inflateRaw(bytes) {
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
  return new Response(stream).arrayBuffer().then((buffer) => new Uint8Array(buffer));
}

async function extractDotLottieAnimation(bytes) {
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const decoder = new TextDecoder();
  let offset = 0;

  while (offset + 30 <= bytes.length) {
    const signature = view.getUint32(offset, true);
    if (signature !== 0x04034b50) break;

    const flags = view.getUint16(offset + 6, true);
    const compression = view.getUint16(offset + 8, true);
    const compressedSize = view.getUint32(offset + 18, true);
    const fileNameLength = view.getUint16(offset + 26, true);
    const extraLength = view.getUint16(offset + 28, true);
    const nameStart = offset + 30;
    const name = decoder.decode(bytes.subarray(nameStart, nameStart + fileNameLength));
    const dataStart = nameStart + fileNameLength + extraLength;

    if (flags & 0x8) {
      throw new Error('Unsupported zip data descriptor');
    }

    const payload = bytes.subarray(dataStart, dataStart + compressedSize);
    offset = dataStart + compressedSize;

    const isAnimationJson =
      name.endsWith('animation.json') || (name.endsWith('.json') && !name.endsWith('manifest.json'));
    if (!isAnimationJson) continue;

    let jsonBytes = payload;
    if (compression === 8) jsonBytes = await inflateRaw(payload);
    else if (compression !== 0) throw new Error('Unsupported zip compression');

    return JSON.parse(decoder.decode(jsonBytes));
  }

  throw new Error('animation.json not found in .lottie');
}

async function loadLottieJson(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch logo animation');

  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);

  if (bytes[0] === 0x50 && bytes[1] === 0x4b) {
    return extractDotLottieAnimation(bytes);
  }

  return JSON.parse(new TextDecoder().decode(bytes));
}

function playHeaderLogo(container, animationData) {
  container.replaceChildren();
  window.lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
      progressiveLoad: true,
    },
  });
}

function initHeaderLogoLottie() {
  if (!window.lottie) return;

  document.querySelectorAll('[data-header-logo-lottie]').forEach((container) => {
    if (container.dataset.lottieReady === 'true') return;

    const src = container.dataset.src;
    const fallbackSrc = container.dataset.fallbackSrc;
    if (!src) return;

    container.dataset.lottieReady = 'true';

    loadLottieJson(src)
      .catch((error) => {
        if (!fallbackSrc || fallbackSrc === src) throw error;
        return loadLottieJson(fallbackSrc);
      })
      .then((animationData) => playHeaderLogo(container, animationData))
      .catch(() => {
        container.dataset.lottieReady = 'false';
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderLogoLottie, { once: true });
} else {
  initHeaderLogoLottie();
}
